import React from 'react'
import { colors } from '../../../../styles/vars/colors.style'

const ExpeditionRoute4 = ({
  width = 158,
  height = 285,
  stroke = colors.dark,
  mask = colors.light,
  opacity = 1,
  pathLength = 427,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 158 285"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        opacity={opacity}
        stroke={stroke}
        strokeWidth={1}
        strokeDasharray="2 3"
        d="M113.001,-31C23.5007,20.5 -3.4993,70 1.0007,122C5.5007,174 116,249.237 157,284.501"
      />
      <path
        opacity={opacity}
        stroke={mask}
        strokeWidth={2}
        ref={forwardRef.line}
        strokeDashoffset={0}
        strokeDasharray={pathLength}
        d="M113.001,-31C23.5007,20.5 -3.4993,70 1.0007,122C5.5007,174 116,249.237 157,284.501"
      />
    </svg>
  )
}

export default ExpeditionRoute4
